import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { useTranslation } from "react-i18next";

export function useRemoteCreateEquipment() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, FormData>({
    key: "create-equipment",
    url: "/equipment-inventory",
    snackbarTextOnSuccess: t("Successfully created an equipment"),
    snackbarTextFunOnFail: error => `${(error as any).response.data.message}`
  });
}
